import { apiDate, optional, string, z, zodLess, ZodLessInfer } from '@kaiizen/zod-less';
import { optionalApiDate, optionalMetadataSchema } from '../schemaLib';
import { ApiOrgContractorBaseSchema } from './ApiOrgContractorBaseSchema';

export const ApiOrgMarketContractorSchema = zodLess({
  orgContractorId: string,
  orgMarketId: string,
  createdAt: apiDate,
  updatedAt: apiDate,
  orgContractor: ApiOrgContractorBaseSchema,
});

export const ApiOrgMarketSchema = zodLess({
  id: string,
  orgId: string,
  name: string,
  activeProjectCount: z.number().int().nonnegative().optional(),
  closedProjectCount: z.number().int().nonnegative().optional(),
  archivedProjectCount: z.number().int().nonnegative().optional(),
  needsAttentionProjectCount: z.number().int().nonnegative().optional(),
  defaultTemplateId: string.nullable().optional(),
  defaultManagerIds: z.array(string).optional(),
  zipCodes: z.array(string).default([]),
  customerMetadata: optionalMetadataSchema,
  createdAt: apiDate,
  updatedAt: apiDate,
  archivedAt: optionalApiDate,
  marketContractors: optional([ApiOrgMarketContractorSchema]),
});
export const ApiCreateOrgMarketSchema = ApiOrgMarketSchema.omit({
  id: true,
  activeProjectCount: true,
  closedProjectCount: true,
  archivedProjectCount: true,
  needsAttentionProjectCount: true,
  createdAt: true,
  updatedAt: true,
  archivedAt: true,
  orgId: true,
  marketContractors: true,
});
export const ApiUpdateOrgMarketSchema = ApiOrgMarketSchema.omit({
  id: true,
  activeProjectCount: true,
  closedProjectCount: true,
  archivedProjectCount: true,
  needsAttentionProjectCount: true,
  createdAt: true,
  updatedAt: true,
  orgId: true,
  marketContractors: true,
}).extend({
  zipCodes: z.array(string).optional(),
  defaultManagerIds: z.array(string).optional(),
  archivedAt: string.nullable().optional(),
}).partial();
export type ApiOrgMarket = ZodLessInfer<typeof ApiOrgMarketSchema>;
export type ApiCreateOrgMarket = ZodLessInfer<typeof ApiCreateOrgMarketSchema>;
export type ApiUpdateOrgMarket = ZodLessInfer<typeof ApiUpdateOrgMarketSchema>;

export const getOrgMarketsQueryKeyPrefix = (): string => `orgMarkets`;
export const getOrgMarketQueryKey = (id?: string | null): string => `orgMarket/${id}`;
export const getOrgMarketsQueryKey = (archived?: boolean, search?: string): string =>
  `${getOrgMarketsQueryKeyPrefix()}/${archived ? 'archived' : 'active'}/${search?.trim() || 'all'}`;
